import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse, PaginatedResponse } from 'src/common/interfaces';
import { PublicProfileParams, PublicProfileRoom } from 'src/common/interfaces/public-profile';
import { PUBLIC_PROFILE_URL } from 'src/features/public-profile/public-profile.slice';

export const publicProfileCreatedRoomsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPublicProfileCreatedRooms: builder.query<ApiResponse<PaginatedResponse<PublicProfileRoom>>, PublicProfileParams>(
      {
        query: ({ user, limit, offset, page }: PublicProfileParams) => ({
          url: `${PUBLIC_PROFILE_URL}/created-rooms`,
          params: {
            user,
            limit,
            offset,
            page,
          },
        }),
      },
    ),
  }),
});

export const { useGetPublicProfileCreatedRoomsQuery } = publicProfileCreatedRoomsApiSlice;
